module.exports = __webpack_public_path__ + "static/media/captions_Irish_Peerless.5b833c5a.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/subtitles/captions_Irish_Peerless.vtt
// module id = 118
// module chunks = 0